import { usePensionNameValue } from "@/shared/client";
import { type RoomType } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import { RoomDescription } from "./components";
import { CustomTitle } from "./roomDetail.style";

export const RoomDetail = ({ room }: { room: RoomType }) => {
    const pensionName = usePensionNameValue();
    const { isMobile } = MEDIA();

    return (
        <Box position="relative" background="#f8f8f8">
            <Center as="section">
                <Flex
                    maxW="1600px"
                    w="100%"
                    flexDir="column"
                    rowGap={isMobile ? "16px" : "24px"}
                    p={isMobile ? "0 16px" : "0 48px"}
                >
                    <Flex w="100%" flexDir="column">
                        <CustomTitle>{pensionName.kor}의 객실</CustomTitle>
                        <Text>{pensionName.eng}</Text>
                    </Flex>
                    <RoomDescription room={room} />
                </Flex>
            </Center>
        </Box>
    );
};
